module.exports = __webpack_public_path__ + "static/media/carousel-active.d2990dc0.svg";